export default {
  en: 'Create Your Avatar',
  it: 'Crea Il Tuo Avatar'
};
